import { Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import {
	EolResults,
	RetrofitService,
	VahanData,
} from "../../services/retrofit.service";

@Component({
	selector: "app-vahan-portal",
	templateUrl: "./vahan-portal.component.html",
	styleUrls: ["./vahan-portal.component.css"],
})
export class VahanPortalComponent implements OnInit {
	constructor(private retrofitService: RetrofitService) {}

	vehicleNum: string = null;
	dataStatus: "fetched" | "fetching" | "not-fetched" = "not-fetched";
	vahanData: VahanData = null;

	readonly tableRows: { label: string; key: keyof VahanData }[] = [
		{ label: "Test ID", key: "test_id" },
		{ label: "Test Date", key: "test_date" },
		{ label: "Vehicle Number", key: "vehicle_number" },
		{ label: "PKN ID", key: "pkn_id" },
		{ label: "Front Battery Unique ID", key: "front_battery_unique_id" },
		{ label: "Rear Battery Unique ID", key: "rear_battery_unique_id" },
		{ label: "Motor ID Serial Number", key: "motor_id_serial_number" },
		{
			label: "Motor Controller Serial Number",
			key: "motor_controller_serial_number",
		},
		{ label: "Front BMS Unique ID", key: "front_bms_unique_id" },
		{ label: "Rear BMS Unique ID", key: "rear_bms_unique_id" },
		{ label: "Bytebeam ID", key: "bytebeam_id" },
		{ label: "E^port ID", key: "eport_id" },
	];

	readonly eolResultRows: { label: string; key: keyof EolResults }[] = [
		{ label: "Final Result", key: "final_result" },
		{ label: "Pre Load", key: "pre_load" },
		{ label: "Post Load", key: "post_load" },
		{ label: "Fast Charge", key: "fast_charge" },
		{ label: "On Road", key: "on_road" },
	];

	ngOnInit(): void {}

	onGetData() {
		if (!this.vehicleNum) {
			Swal.fire({
				icon: "warning",
				title: "Test ID Required",
				html: "<p>Please enter a valid Test ID to fetch Vahan Portal data.</p>",
			});
			return;
		}
		this.getVahanData(this.vehicleNum);
	}

	getVahanData(vehicleNum: string) {
		this.dataStatus = "fetching";
		this.vahanData = null;

		this.retrofitService.getVahanData(vehicleNum).subscribe({
			next: (res) => {
				this.dataStatus = "fetched";
				const { body: responseBody, ok } = res;

				if (!ok) {
					this.triggerErrorSwal("Error fetching Vahan Portal data.");
					this.resetForm();
					return;
				}

				if (!responseBody.success) {
					this.triggerErrorSwal(responseBody.message);
					this.resetForm();
					return;
				}

				this.vahanData = responseBody.data;
			},
			error: (error: Error) => {
				this.dataStatus = "not-fetched";
				this.triggerErrorSwal(
					"Invalid vehicle number provided. Please try again.",
				);
			},
		});
	}

	copyToClipboard(value: string) {
		if (!value) {
			return;
		}
		navigator.clipboard.writeText(value).then(() => {
			Swal.fire({
				icon: "success",
				title: "Copied!",
				text: "Value copied to clipboard.",
				timer: 1200,
				showConfirmButton: false,
				toast: true,
				position: "top-end",
			});
		});
	}

	triggerErrorSwal(message: string) {
		Swal.fire({
			icon: "error",
			title: "Error",
			html: `<p>${message}</p>`,
		});
	}

	resetForm() {
		this.vahanData = null;
		this.dataStatus = "not-fetched";
	}
}
